import { createContext } from 'react';

import { DialogsContextType } from './DialogsContext.types';

export const DialogsContext = createContext<DialogsContextType>({} as DialogsContextType);
